import { memo, type ReactNode } from 'react';
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';

export type MindMapTurboNodeData = {
    label: ReactNode;
    icon?: ReactNode;
};

export default memo(({ data, isConnectable }: NodeProps<Node<MindMapTurboNodeData>>) => {
    return (
        <>
            <Handle
                type="target"
                id="top"
                position={Position.Top}
                isConnectable={isConnectable}
                className="turbo-node-handle"
            />

            <div className="wrapper gradient">
                <div className="inner">
                    <div className="turbo-node">
                        {data.icon}
                        <div className="turbo-node-content">{data.label}</div>
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                id="bottom"
                position={Position.Bottom}
                isConnectable={isConnectable}
                className="turbo-node-handle"
            />
        </>
    );
});


